module.exports = __webpack_public_path__ + "img/camping-ideas.2.adc4410.jpg";